import { useIntlTranslations } from '@libs/intl/intl.hooks';
import { Typography } from '@mui/material';

type VisitClosedWarningProps = {
  isVisitClosed: boolean;
};

const VisitDetailClosedWarning = ({ isVisitClosed }: VisitClosedWarningProps) => {
  const { t } = useIntlTranslations();
  if (!isVisitClosed) {
    return null;
  }

  return (
    <Typography color="info" fontWeight="600" align="center">
      {t('visitDetail.finishProcedureWarrning')}
    </Typography>
  );
};

export default VisitDetailClosedWarning;
